<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-icon small>
      location_on
    </v-icon>
    {{ yacht.current_base.name }}, {{ yacht.current_base.country.name }}
  </div>
</template>

<script>
  import Yacht from '@/models/Yacht'

  export default {
    name: 'InUse',
    props: {
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        yachtStatuses: Yacht
      }
    },
    computed: {
    }
  }
</script>
